// Run async tasks in parallel with a concurrency limit. Like Promise.all but
// only `limit` tasks run at the same time — important for uploads where we
// don't want to saturate the connection or hit the backend rate limit.
//
// Usage:
//   const results = await runWithConcurrency(items, 4, async (item) => {
//       const { data } = await api.post(...);
//       return data;
//   });
export async function runWithConcurrency(items, limit, worker) {
    const results = new Array(items.length);
    let next = 0;
    let firstErr = null;
    const runners = Array.from({ length: Math.min(limit, items.length) }, async () => {
        while (firstErr === null) {
            const i = next++;
            if (i >= items.length) return;
            try {
                results[i] = await worker(items[i], i);
            } catch (err) {
                if (firstErr === null) firstErr = err;
            }
        }
    });
    await Promise.all(runners);
    if (firstErr) throw firstErr;
    return results;
}
